import { render, staticRenderFns } from "./MyFileImport.vue?vue&type=template&id=32939f38&scoped=true&"
import script from "./MyFileImport.vue?vue&type=script&lang=js&"
export * from "./MyFileImport.vue?vue&type=script&lang=js&"
import style0 from "./MyFileImport.vue?vue&type=style&index=0&id=32939f38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32939f38",
  null
  
)

export default component.exports